(function(){
    'use strict';

    angular.module('Services').service('JobMapListService', JobMapListService);

    JobMapListService.$inject = ['FleetService', 'toastr', '$interval'];

    function JobMapListService(FleetService, toastr, $interval){
        return function (mapData){
            let subscription = null;

            let listData = {
                config: {
                    template: '/templates/pages/jobs/add-ons/jobs-list.html'
                },
                viewDriverRoute: function (driver) {
                    if(subscription){
                        $interval.cancel(subscription);
                        subscription = null;
                    }
                    viewDriverRoute(driver);
                    subscription = $interval(function () {
                        viewDriverRoute(driver);
                    }, 60000);
                },
                hideRoutes: function () {
                    if(subscription){
                        $interval.cancel(subscription);
                        subscription = null;
                    }
                    hideRoutes();
                },
                onClick: function (row) {
                    mapData.map.setCenter({
                        lat: row.latitude,
                        lng: row.longitude
                    });
                    mapData.map.setZoom(16);
                    row.setSelected(row);
                    row.onPinClick(row.marker);
                },
                mapRoutes: [],
                data: mapData.originalList,
            };

            function viewDriverRoute(driver) {
                listData.fetchingRoute = true;
                FleetService.Jobs.getJobDetails(driver.jobs[0].id,data=>{
                    hideRoutes();
                    FleetService.Routes.getMapRoute(route=>{
                        route.routes.forEach(route=>{
                            const driverPosition = new google.maps.Marker({
                                icon: {
                                    path: google.maps.SymbolPath.CIRCLE,
                                    scale: 7
                                },
                                position: {
                                    lat: data.driver.latitude,
                                    lng: data.driver.longitude
                                }
                            });
                            const decoded = google.maps.geometry.encoding.decodePath(route.overviewPolyline.encodedPath);
                            const line = new google.maps.Polyline({
                                path: decoded,
                                strokeColor: '#ef2139',
                                strokeOpacity: 1.0,
                                strokeWeight: 4,
                                zIndex: 3
                            });
                            listData.mapRoutes.push(line, driverPosition);
                            line.setMap(mapData.map);
                            driverPosition.setMap(mapData.map);

                            listData.fetchingRoute = false;
                        });
                        if(listData.mapRoutes.length){
                            zoomToObject(listData.mapRoutes[0]);
                        }
                    }, err=>{
                        listData.fetchingRoute = false;
                        toastr.error('Unable to get driver\'s route', err.message);
                    }, {
                        driverId: data.driver.id
                    })
                },err=>{
                    listData.fetchingRoute = false;
                    toastr.error('Unable to get driver\'s route', err.message);
                });
            }
            function zoomToObject(obj){
                let bounds = new google.maps.LatLngBounds();
                let points = obj.getPath().getArray();
                for (let n = 0; n < points.length ; n++){
                    bounds.extend(points[n]);
                }
                mapData.map.fitBounds(bounds);
            }

            function hideRoutes() {
                if(listData.mapRoutes.length){
                    listData.mapRoutes.forEach(line=>{
                        line.setMap(null);
                    });
                    listData.mapRoutes = [];
                }
            }
            this.listData = listData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/lists/JobMapListService.js